import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import uuidv4 from 'uuid/v4';
import isEqual from 'lodash/isEqual';
import set from 'lodash/set';
export default {
  name: 'NiotaClassicDevicetypesPacketParserTypeDefinitions',
  mixins: [formMixin, parserTypesMixin],
  props: {
    variables: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    custom: {
      type: Boolean,
      required: false,
      default: false
    },
    calculateElements: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    parseElements: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      variablesInternal: {}
    };
  },
  computed: {
    modeClass: function modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    variableTableHeaders: function variableTableHeaders() {
      return [{
        value: 'order',
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.order'),
        sortable: false
      }, {
        value: 'name',
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariable'),
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.type'),
        sortable: false
      } // {
      //   text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.layout'),
      //   sortable: false,
      // },
      ];
    },
    computedVariables: function computedVariables() {
      var _this = this;

      var targetVars = [];

      if (this.custom) {
        var parserConfig = this.predefinedParserVars.find(function (parser) {
          return parser.id === _this.custom;
        });
        targetVars = Object.keys(parserConfig.fields).concat(this.calculateElements.map(function (e) {
          return e.target;
        }));
      } else {
        targetVars = this.parseElements.concat(this.calculateElements).map(function (e) {
          return e.target;
        });
      } // do not show empty target variables


      targetVars = targetVars.filter(function (tv) {
        return tv !== '';
      });
      var vars = this.variablesInternal;

      if (!vars) {
        return [];
      } // filter out variables which's target have been deleted


      var deletedTargets = Object.keys(vars).filter(function (v) {
        return targetVars.findIndex(function (tv) {
          return tv === v;
        }) === -1;
      });
      deletedTargets.forEach(function (t) {
        delete vars[t];
      });
      var defVariables = Object.keys(vars).sort(function (a, b) {
        return vars[a].order - vars[b].order;
      }); // update the indices of the order, in case targets have been deleted

      defVariables.forEach(function (t, i) {
        vars[t].order = i;
      }); // find new targets that have no mapping yet

      var newVars = targetVars.filter(function (v) {
        return defVariables.findIndex(function (dv) {
          return dv === v;
        }) === -1;
      });

      if (newVars.length) {
        newVars.forEach(function (v) {
          vars[v] = {
            name: v,
            key: v,
            order: Object.keys(vars).length,
            type: 'auto'
          };
        });
        defVariables = Object.keys(vars).sort(function (a, b) {
          return vars[a].order - vars[b].order;
        });
      }

      return defVariables;
    }
  },
  watch: {
    variables: {
      handler: function handler(val) {
        this.variablesInternal = cloneDeep(val);
      },
      immediate: true
    },
    computedVariables: {
      handler: function handler(newVal, oldVal) {
        if (isEqual(newVal, oldVal)) {
          return;
        }

        this.emitChanges();
      },
      deep: true
    }
  },
  methods: {
    uuidv4: uuidv4,
    changeVariableOrder: function changeVariableOrder(variable, direction) {
      var vars = cloneDeep(this.variablesInternal);
      var currentIndex = vars[variable].order;
      var newIndex = Math.min(Object.keys(vars).length - 1, Math.max(0, currentIndex + (direction === 'up' ? -1 : 1)));

      if (newIndex !== currentIndex) {
        var otherVar = Object.keys(vars).find(function (v) {
          return vars[v].order === newIndex;
        });
        vars[otherVar].order = currentIndex;
        vars[variable].order = newIndex;
      }

      this.variablesInternal = vars;
      this.emitChanges();
    },
    variableTypeSelected: function variableTypeSelected(variable) {
      // if a variable-type was selected, also set the suffix to the base-unit (if it is a number-type)
      // ONLY if no suffix had been chosen yet
      var vars = cloneDeep(this.variablesInternal);

      if (vars[variable].value_type && vars[variable].value_type.base_unit) {
        if (!vars[variable].suffix || vars[variable].suffix.trim() === '') {
          vars[variable].suffix = vars[variable].value_type.base_unit;
        }
      }

      set(vars[variable], 'properties.unit', vars[variable]['value_type']['name']);
      this.variablesInternal = vars;
      this.emitChanges();
    },
    emitChanges: function emitChanges() {
      var clonedVariables = cloneDeep(this.variablesInternal);

      if (isEqual(this.variables, clonedVariables)) {
        return;
      }

      this.$emit('variables-updated', clonedVariables);
    }
  }
};